// Public article dates are stored in a parseable English form (e.g.
// "Apr 18, 2026") and are intentionally NOT translated by the ML pipeline.
// Re-format them for the active language so public pages read fully localized
// (e.g. "2026年4月18日", "18 avr. 2026", "١٨ أبريل ٢٠٢٦").
const LOCALE_MAP = { pt: 'pt-PT', en: 'en-GB', fr: 'fr-FR', ar: 'ar', zh: 'zh-CN' };

export const formatLocalizedDate = (raw, language) => {
  if (!raw || typeof raw !== 'string') return raw;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return raw;
  try {
    return new Intl.DateTimeFormat(LOCALE_MAP[language] || 'en-GB', {
      day: 'numeric', month: 'short', year: 'numeric',
    }).format(d);
  } catch (_) {
    return raw;
  }
};
